<div>

  <ion-grid>
    <form class="address__form" [formGroup]='address_form'>
      Address
      <ion-item lines="none" class="">
        <ion-label position="stacked">First Name <span class="err">*</span></ion-label>
        <ion-input name="first_name" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="first_name" [ngClass]="{'is-invalid': submitted && validation.first_name.errors}"></ion-input>
      </ion-item>
      <p *ngIf='submitted && validation.first_name.errors'>Enter First Name</p>

      <ion-item lines="none" class="">
        <ion-label position="stacked">Last Name <span class="err"></span></ion-label>
        <ion-input name="last_name" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="last_name"></ion-input>
      </ion-item>

      <ion-item lines="none" class="">
        <ion-label position="stacked">Address <span class="err">*</span></ion-label>
        <ion-input name="address" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="address" [ngClass]="{'is-invalid': submitted && validation.first_name.errors}"></ion-input>
      </ion-item>
      <p *ngIf='submitted && validation.address.errors'>Enter your address</p>

      <ion-item lines="none" class="">
        <ion-label position="stacked">City <span class="err">*</span></ion-label>
        <ion-input name="city" class="form-input" formControlName="city" autocomplete="false" required="true" [ngClass]="{'is-invalid': submitted && validation.first_name.errors}"></ion-input>
      </ion-item>
      <p *ngIf='submitted && validation.city.errors'>Enter your city</p>

      <ion-item lines="none" class="">
				<ion-label class="box-label" position="stacked">Country <span class="err">*</span></ion-label>
				<ion-select  name="country" formControlName="country" class="ion__select" interface="popover" (ionChange)="value_changed($event)" value="{{address_info.country}}">
					<ion-select-option *ngFor="let c of country_list" value="{{c.name}}">{{c.name}}</ion-select-option>
        </ion-select>
			</ion-item>

			<ion-item lines="none" class="">
				<ion-label class="box-label" position="stacked">State <span class="err">*</span></ion-label>
				<ion-select name="state" formControlName="state" class="ion__select" interface="popover" value="{{address_info.state}}">
					<ion-select-option *ngFor="let c of states_list" value="{{c.name}}">{{c.name}}</ion-select-option>
				</ion-select>
			</ion-item>

      <ion-item lines="none" class="">
        <ion-label position="stacked">Postal Code <span class="err">*</span></ion-label>
        <ion-input name="zipcode" class="form-input" formControlName="zipcode" autocomplete="false" required="true" [ngClass]="{'is-invalid': submitted && validation.zipcode.errors}"></ion-input>
      </ion-item>
      <p *ngIf='submitted && validation.zipcode.errors'>postal code is required</p>
     

      <div class="ion__button">
        <ion-button fill="clear" expand="full" (click)="address_type == 'Edit'?edit_address():insert_address()">{{address_type == 'Edit'?'Update':'Save'}}</ion-button>
      </div>

    </form>
  </ion-grid>
</div>


<!-- <ion-footer>
  <ion-toolbar [formGroup]='address_form' class="ion__toolbar">

  </ion-toolbar>
</ion-footer> -->
